import { Injectable, inject } from '@angular/core';
import { Api, Response } from './api';
import { KeyvalService } from './keyval.service';
import { logger } from './logger';
import { toError } from './utils/to-error';

@Injectable({
    providedIn: 'root'
})
export class CachedApi {

    private api = inject(Api);
    private keyval = inject(KeyvalService);

    async get<T>(path: string): Promise<Response<T>> {
        const cachekey = `cached-api:${path}`
        try {
            const result = await this.api.get<T>(path);
            if (result.state != 'ok') {
                throw toError(result.error ?? 'Unknown error');
            }
            await this.keyval.setItem(cachekey, result);
            return result;
        } catch (error) {
            logger.warn(`CachedApi: Failed fetching ${path}`);
            const cached = await this.keyval.getItem(cachekey);
            if (cached) {
                logger.info(`CachedApi: Returning cached value for ${path}`);
                return cached;
            }
            throw error;
        }
    }

    async post<T>(path: string, body?: any) {
        const result = await this.api.post<T>(path, body);
        return result;
    }

}
